module.exports = __webpack_public_path__ + "static/media/tick-policy.1edc260c.svg";